import N from "./getFormattedCurrencyPostfix.mjs";
function D(d = 0, s = "SEK", e = !0) {
  let l = 0;
  const c = typeof e == "object" ? {
    formatPostfix: (e == null ? void 0 : e.formatPostfix) ?? !0,
    trimTrailingZeros: (e == null ? void 0 : e.trimTrailingZeros) ?? !0,
    showAsManyDecimalsAsNeeded: (e == null ? void 0 : e.showAsManyDecimalsAsNeeded) ?? !1,
    maxAsManyDecimalsAsNeeded: (e == null ? void 0 : e.maxAsManyDecimalsAsNeeded) ?? 8,
    onlyShowAsManyDecimalsAsNeededWhenZeroInt: (e == null ? void 0 : e.onlyShowAsManyDecimalsAsNeededWhenZeroInt) ?? !0,
    showCurrencyPostfix: (e == null ? void 0 : e.showCurrencyPostfix) ?? !0
  } : {
    formatPostfix: e,
    trimTrailingZeros: !0,
    showAsManyDecimalsAsNeeded: !1,
    maxAsManyDecimalsAsNeeded: 8,
    onlyShowAsManyDecimalsAsNeededWhenZeroInt: !0,
    showCurrencyPostfix: !0
  };
  if (!d || Number.isNaN(Number(d)))
    l = 0;
  else if (c.trimTrailingZeros && Number.isInteger(Number(d)))
    l = d;
  else if (c.showAsManyDecimalsAsNeeded) {
    l = Number(d).toFixed(c.maxAsManyDecimalsAsNeeded);
    const [u, A] = l.split("."), n = A != null && A.length > 2 ? A.replace(/0+$/, "") : A;
    (c.onlyShowAsManyDecimalsAsNeededWhenZeroInt ? u === "0" : !0) && u != null && n != null && n.length > 2 ? l = `${u}.${n}` : l = Number(d).toFixed(2);
  } else
    l = Number(d).toFixed(2), c.trimTrailingZeros && l.endsWith(".00") && (l = Number.parseInt(l, 10).toString());
  if (c.showCurrencyPostfix === !1)
    return `${l}`;
  const y = c.formatPostfix ? N(s) : s;
  return `${l} ${y}`;
}
export {
  D as default
};
